/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ColumnSortDescription } from "./ColumnSortDescription";
import { markType } from "igniteui-react-core";
import { FormatGroupTextEventArgs } from "./FormatGroupTextEventArgs";
/**
 * @hidden
 */
var ColumnGroupDescription = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnGroupDescription, _super);
    function ColumnGroupDescription(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = this;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0:
                {
                    _this = _super.call(this, 0) || this;
                    _this.j = null;
                    _this.l = null;
                    _this.i = false;
                    _this.g = 0;
                    _this.formatText = null;
                    _this.i = false;
                    _this.g = 11;
                }
                break;
            case 1:
                {
                    var c = _rest[0];
                    _this = _super.call(this, 1, c) || this;
                    _this.j = null;
                    _this.l = null;
                    _this.i = false;
                    _this.g = 0;
                    _this.formatText = null;
                    _this.i = false;
                    _this.g = 11;
                }
                break;
            case 2:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    _this = _super.call(this, 2, c, d) || this;
                    _this.j = null;
                    _this.l = null;
                    _this.i = false;
                    _this.g = 0;
                    _this.formatText = null;
                    _this.i = false;
                    _this.g = 11;
                }
                break;
        }
        return _this;
    }
    Object.defineProperty(ColumnGroupDescription.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            this.j = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnGroupDescription.prototype, "m", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            this.l = a;
        },
        enumerable: true,
        configurable: true
    });
    ColumnGroupDescription.prototype.n = function (a, b, c) {
        var _this = this;
        var d = null;
        if (this.formatText != null) {
            d = ((function () {
                var $ret = new FormatGroupTextEventArgs();
                $ret.d = _this.f;
                $ret.a = a;
                $ret.c = b;
                $ret.b = c;
                return $ret;
            })());
            this.formatText(this, d);
        }
        return d == null ? c : d.b;
    };
    ColumnGroupDescription.$t = markType(ColumnGroupDescription, 'ColumnGroupDescription', ColumnSortDescription.$);
    return ColumnGroupDescription;
}(ColumnSortDescription));
export { ColumnGroupDescription };
//# sourceMappingURL=ColumnGroupDescription.js.map
